import type { FilterSpecification } from "mapbox-gl"
import type { View } from "@/types"

type TransactionFilter = NonNullable<NonNullable<View["filter"]>["transaction"]>

export function transactionBuildingPriceFilter(filter: TransactionFilter | undefined): FilterSpecification {
	const range = filter?.pricePerBuildingSqft
	if (range?.min == null && range?.max == null) return ["all"]

	return [
		"all",
		["has", "price_per_building_sqft"],
		["!=", ["get", "price_per_building_sqft"], null],
		...(range.min != null ? [[">=", ["to-number", ["get", "price_per_building_sqft"]], range.min]] : []),
		...(range.max != null ? [["<=", ["to-number", ["get", "price_per_building_sqft"]], range.max]] : []),
	] as FilterSpecification
}
